import React, { createContext, useContext } from 'react';
import { RegularText } from '@/lib/Text';
import { colors } from '@/lib/colors';
import { formatExceptionRule, isHiddenInMode } from '@/features/coachCommissionTable';
import type { ExceptionRatesEditor } from './useExceptionRatesEditor';

/**
 * 기본 정산 요율 표의 강사별 「예외 수업료」 칸.
 * - 규칙 없음: 「+ 설정」(읽기 전용이면 '-')
 * - 규칙 있음: 「n개 · 수정」, 마우스를 올리면 규칙 문구 전체
 * 기본 정산에서 쓰지 않는 「재등록 수강권 전체」 예외는 개수에서 뺀다(저장값은 그대로).
 */
/**
 * 기본 정산 요율 표가 칸에 편집기를 넘기는 통로. 열 정의(셀 함수)에 편집기를 묶으면 예외 응답이 올 때마다
 * 열이 다시 만들어져 옆 비율 칸의 입력 중 값이 사라진다 — 그래서 열은 한 번만 만들고 값은 컨텍스트로 읽는다.
 */
export const BaseExceptionEditorContext = createContext<ExceptionRatesEditor | null>(null);

const BaseExceptionRatesCell = ({ coachId }: { coachId: string }) => {
    const editor = useContext(BaseExceptionEditorContext);
    if (!editor || !editor.hasCoach(coachId)) return <span className="text-[#9CA3AF]">-</span>;
    const rules = editor.rulesOf(coachId).filter((rule) => !isHiddenInMode(rule, 'base'));
    if (rules.length === 0) {
        if (editor.readOnly) return <span className="text-[#9CA3AF]">-</span>;
        return (
            <button
                type="button"
                className="bg-transparent border-0 p-0 cursor-pointer hover:underline"
                onClick={() => editor.open(coachId)}
            >
                <RegularText fontSize={15} color={colors.primary}>
                    + 설정
                </RegularText>
            </button>
        );
    }
    const texts = rules.map((rule) => formatExceptionRule(rule, editor.categoryName, 'base'));
    return (
        <button
            type="button"
            title={texts.join('\n')}
            className="bg-transparent border-0 p-0 cursor-pointer hover:underline"
            onClick={() => editor.open(coachId)}
        >
            <RegularText fontSize={15} color={colors.primary}>
                {`${rules.length}개 · ${editor.readOnly ? '보기' : '수정'}`}
            </RegularText>
        </button>
    );
};

export default BaseExceptionRatesCell;
